export enum Status {
  PENDING = 'pending',
  APPOINTMENT_PENDING = 'appointment pending',
  STARTED = 'started',
  IMAGES_AVAILABLE = 'images available',
  COMPLETE = 'complete',
}
